import { gql } from "apollo-boost"

export const getIdMeansOfVerification = gql`
 mutation Mutation($year: Float!, $month: Float!, $getIdMeansOfVerificationCommentsId: ID!) {
  GetIdMeansOfVerificationComments(year: $year, month: $month, id: $getIdMeansOfVerificationCommentsId)
}
`